<template>
  <div
    class="visualization explore-visualization"
    v-loading="loading"
    element-loading-spinner="presupuesto-loader"
  >
    <div class="row">
      <div class="col-sm-9">
        <el-radio-group v-model="periodo">
          <el-radio-button v-for="p in periodos" :key="p" :label="p"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="col-sm-3 text-right">
        <div class="mode-selector">
          <span class="title">Ver como</span>
          <div class="view-buttons">
            <el-tooltip content="Gráfico">
              <a href="#" @click.prevent="mode = 'chart'" :class="{active: mode === 'chart'}">
                <i class="material-icons">dashboard</i>
              </a>
            </el-tooltip>
            <el-tooltip content="Tabla">
              <a href="#" @click.prevent="mode = 'table'" :class="{active: mode === 'table'}">
                <i class="material-icons">view_list</i>
              </a>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-show="mode === 'chart'">
      <div class="col-sm-3">
        <ol v-show="mode === 'chart'" class="breadcrumb breadcrumb-vertical">
          <li
            class="breadcrumb-item"
            v-for="(b,i) in breadcrumb"
            :key="i"
            :class="{active: i === breadcrumb.length - 1}"
            @click.prevent="pop()"
          >
            <div class="title">{{b.data.type}}</div>
            <div>
              <a v-if="i !== breadcrumb.length - 1" href="#">{{b.data.name}}</a>
              <span v-else>{{b.data.name}}</span>
            </div>
            <div class="amount">{{moneyFormatter(b.value)}}</div>
            <!--<div class="percentage">{{numeral(b.value / (b.parent ? b.parent.value : b.value)).format('0.00%')}}</div>-->
          </li>
        </ol>
      </div>
      <div class="col-sm-9">
        <div class="row">
          <div class="col-sm-8">
            <h4 v-if="breadcrumb.length > showBreadcrumbFromElement">
              {{breadcrumb[breadcrumb.length - 1].data.name}}&nbsp;&nbsp;&nbsp;
              <a
                class="btn btn-primary btn-nofill"
                href="#"
                @click.prevent="detailClicked(breadcrumb[breadcrumb.length - 1])"
              >
                Ver detalle de ejecución
                <i class="material-icons">arrow_forward</i>
              </a>
            </h4>
          </div>
          <div v-if="searchable" class="col-sm-4">
            <div class="text-right">
              <el-autocomplete
                v-model="search"
                :fetch-suggestions="querySearch"
                placeholder="Buscar"
                @select="detailClicked"
              ></el-autocomplete>
            </div>
          </div>
        </div>
        <treemap-chart
          v-show="details === null"
          :width="825"
          :height="510"
          :data="filteredHierarchicalData"
          :breadcrumb.sync="breadcrumb"
          ref="treemapChart"
          @detail-clicked="detailClicked"
          :colors="colors"
          :ravest="ravest"
        ></treemap-chart>
        <div v-show="details !== null">
          <div>
            <a href="#" @click.prevent="details = null">&lt; Volver al gráfico</a>
          </div>
          <expenses-detail-visualization :where="detailWhere" ref="detailViz"></expenses-detail-visualization>
        </div>
      </div>
    </div>
    <table-chart :height="510" :data="data" v-show="mode === 'table'"></table-chart>

    <visualization-footer :url="this.url"></visualization-footer>
  </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import numeral from 'numeral';
import moneyFormatter from '../../Methods/MoneyFormatter';
import TreemapChart from '../Charts/Treemap';
import TableChart from '../Charts/Table';
import ExpensesDetailVisualization from './ExpensesDetail';
import VisualizationFooter from './Common/Footer';

export default {
    data: function() {
        return {
            loading: false,
            data: [],
            mode: 'chart',
            breadcrumb: [],
            details: null,
            periodo: this.$store.state.defaultYear,
            periodos: [],
            search: ''
        };
    },
    props: {
        //institution: {default: null},
        where: { default: null },
        showBreadcrumbFromElement: { default: 0 },
        detailAction: { default: 'goToURL' },
        searchable: { default: false },
        colors: { default: null },
        ravest: { default: false }
    },
    components: {
        TreemapChart,
        TableChart,
        ExpensesDetailVisualization,
        VisualizationFooter
    },
    methods: {
        numeral: numeral,
        moneyFormatter: moneyFormatter,
        pop: function() {
            this.$refs.treemapChart.pop();
        },
        detailClicked: function(d) {
            if (this.detailAction === 'goToURL') {
                window.location.href = '/institutions/' + d.data.id;
            } else {
                const segments = d.data.id ? d.data.id.split('/') : [];
                const details = {
                    partida: segments[0],
                    capitulo: segments[1],
                    area: segments[2]
                };
                this.details = details;
            }
        },
        refreshData: function() {
            this.loading = true;
            axios.get(this.url).then(response => {
                this.loading = false;
                this.data = response.data;
            });
        },
        querySearch: function(queryString, cb) {
            const results = this.searchableData.filter(d => {
                return d.value.includes(queryString);
            });

            cb(results);
        }
    },
    watch: {
        periodo: function(value) {
            this.$store.commit("setDefaultYear", value)
            this.breadcrumb = [];
            this.refreshData();
        }
    },
    computed: {
        url: function() {
            return (
                '/api/v1/data/pagos?group-by=' +
                JSON.stringify(['partida', 'capitulo', 'area']) +
                '&where=' +
                JSON.stringify(this.computedWhere)
            );
        },
        computedWhere: function() {
            return _.merge(_.clone(this.where), {
                periodo: this.periodo
            });
        },
        detailWhere: function() {
            return _.merge(_.clone(this.computedWhere), this.details);
        },
        searchableData: function() {
            return _(this.data)
                .uniqBy('partida')
                .map(d => {
                    return {
                        value: d.nombre_partida.toLowerCase(),
                        data: {
                            id: d.partida
                        }
                    };
                })
                .value();
        },
        hierarchicalData: function() {
            return {
                id: '',
                type: 'País',
                name: 'GOBIERNO CENTRAL',
                children: _(this.data)
                    .groupBy('partida')
                    .map(function(p) {
                        return {
                            id: p[0].partida,
                            type: 'Institución',
                            name: p[0].nombre_partida,
                            children: _(p)
                                .groupBy('capitulo')
                                .map(function(c) {
                                    return {
                                        id: p[0].partida + '/' + c[0].capitulo,
                                        type: 'Servicio',
                                        name: c[0].nombre_capitulo,
                                        children: _(c)
                                            .map(function(a) {
                                                return {
                                                    id:
                                                        p[0].partida +
                                                        '/' +
                                                        c[0].capitulo +
                                                        '/' +
                                                        a.area,
                                                    type: 'Area',
                                                    name: a.nombre_area,
                                                    size: a.sum
                                                };
                                            })
                                            .value()
                                    };
                                })
                                .value()
                        };
                    })
                    .value()
            };
        },
        filteredHierarchicalData: function() {
            if (this.data.length === 0) {
                return null;
            }

            let node = this.hierarchicalData;

            if (this.where) {
                if (this.where.partida) {
                    node = _(node.children).find({ id: this.where.partida });
                }

                if (this.where.capitulo) {
                    node = _(node.children).find({
                        id: this.where.partida + '/' + this.where.capitulo
                    });
                }

                if (this.where.area) {
                    node = _(node.children).find({
                        id:
                            this.where.partida +
                            '/' +
                            this.where.capitulo +
                            '/' +
                            this.where.area
                    });
                }
            }

            return node;
        }
    },
    mounted: function() {
        this.refreshData();

        axios
            .get(
                '/api/v1/data/pagos?distinct=' +
                    JSON.stringify(['periodo']) +
                    '&order-by=' +
                    JSON.stringify(['periodo'])
            )
            .then(response => {
                this.periodos = response.data.map(d => {
                    return d.periodo;
                });
            });
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/Explore.vue